import React from "react";
import { Button } from "../ui/button";
import { ArrowLeft, ArrowRight, Check } from "lucide-react";

// R5 — extraído MECANICAMENTE de pages/NewOperation.jsx (JSX verbatim; o
// estado vive no componente-pai e chega por `ctx`).
export default function WizardActions({ ctx }) {
  const {
    isCedenteMode,
    backPath,
    setStep,
    step,
    submitting,
    simulating,
    simulationResult,
    simulationError,
    terminalError,
    stepKey,
    totalSteps,
    validReceivables,
    policyRejected,
    liquidoVisivel,
    submit,
    canNext1,
    canNext2,
    canNext3,
    canNextAssinantes,
    requestExit,
  } = ctx;
  return (
    <div className="flex items-center justify-between">
      <Button
        variant="outline"
        onClick={() => (step === 1 ? requestExit(backPath) : setStep(step - 1))}
        className="h-11"
        data-testid="step-back-button"
      >
        <ArrowLeft className="h-4 w-4 mr-1.5" /> Voltar
      </Button>

      {step < totalSteps ? (
        <Button
          onClick={() => setStep(step + 1)}
          disabled={
            (stepKey === "produto" && !canNext1) ||
            (stepKey === "cedente" && !canNext2) ||
            // Erro TERMINAL bloqueia o avanço aqui mesmo (nenhum ajuste do
            // usuário resolve) — em cima do gate histórico do canNext3.
            (stepKey === "recebiveis" && (!canNext3 || !!terminalError)) ||
            (stepKey === "assinantes" && !canNextAssinantes)
          }
          className="bg-[#0055FF] hover:bg-[#0044CC] text-white h-11 font-semibold"
          data-testid="step-next-button"
        >
          Continuar <ArrowRight className="h-4 w-4 ml-1.5" />
        </Button>
      ) : (
        <Button
          onClick={submit}
          disabled={
            submitting || simulating || validReceivables.length === 0 ||
            // Confirmar exige simulacao FRESCA e valida: com erro (ex. taxa
            // fora da faixa) ou sem resultado, nao ha o que confirmar.
            // Veredito REJEITADO (item 16) tambem bloqueia — cobre a corrida
            // de quem avancou antes de a simulacao da etapa 3 responder; o
            // create continua recusando (422) como defesa em profundidade.
            !!simulationError || !simulationResult || policyRejected || !!terminalError ||
            // Money-path fail-closed: o cedente NUNCA confirma sem ver quanto
            // recebe. Ausente/zero ⇒ não há operação a confirmar.
            (isCedenteMode && !liquidoVisivel)
          }
          className="bg-[#0055FF] hover:bg-[#0044CC] text-white h-11 font-semibold"
          data-testid="submit-operation-button"
        >
          {submitting ? "Enviando..." : <>Confirmar e criar operacao <Check className="h-4 w-4 ml-1.5" /></>}
        </Button>
      )}
    </div>
  );
}
